import { Arrange, Button, Spacer, Text } from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';

import * as localStorage from 'utilities/localStorage';
import * as loggerx from 'utilities/loggerx';

import { SLACKID_ONBOARDING_PROGRESS_LOCALSTORAGE_KEY } from '../constants/localStorage';
import { STEPS } from '../constants/steps';

import styles from './styles.module.less';

function OnboardingBanner({
  completed = false,
  emoji,
  title,
  description,
  buttonVariant = 'neutral',
  buttonText,
  onClick,
}) {
  const textColor = completed ? 'white' : 'grey8';

  // If the user has already completed onboarding then the step index should be >= steps.length
  const currentStepIndex =
    localStorage.getLocalStorageKey(
      SLACKID_ONBOARDING_PROGRESS_LOCALSTORAGE_KEY
    )?.lastCompletedStep ?? 0;

  const numOnboardingSteps = Object.keys(STEPS).length;

  // Don't render anything if the user has completed onboarding
  if (currentStepIndex >= numOnboardingSteps) {
    loggerx.error(new Error('Invalid current step index'), {
      message:
        'Slack ID Onboarding Banner step index exceeded number of steps in onboarding path',
    });

    return null;
  }

  return (
    <div
      className={classnames(
        styles.bannerContainer,
        completed ? styles.backgroundPrimary : styles.backgroundBlue
      )}
    >
      <div className={styles.bannerPadding}>
        <Arrange
          gap="2rem"
          justifyContent="space-between"
          alignItems="center"
          height="100%"
        >
          <div className="flex">
            <div className={styles.waveBackground}>
              <Text size="xxlarge" alignment="center">
                {emoji}
              </Text>
            </div>
            <Spacer right="large" />
            <div>
              <Text
                size="large"
                fontWeight="bold"
                color={textColor}
                alignment="left"
              >
                {title}
              </Text>
              <Text size="medium" color={textColor}>
                {description}
              </Text>
            </div>
          </div>
          <div className={styles.whiteBackground}>
            <Button variant={buttonVariant} onClick={onClick}>
              {buttonText}
            </Button>
          </div>
        </Arrange>
      </div>
    </div>
  );
}

export default OnboardingBanner;
